import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';


function CollectionReport() {
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();



    },
        [isAuthenticated, companyId, branchId, permissions, token, logout]);
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('BillNoWise');
    const [tableData, setTableData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');


    // Function to format date as dd/mm/yyyy
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero, months are 0-indexed
        const year = today.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);



    // Radio button change 

    const [Istype, setistype] = useState("1");


    const handleIstypechange = (event) => {
        setistype(event.target.value);
        setData([]);
    };

    // Fetch collection report data

    const fetchTableData = async () => {

        setData([]);
        setLoading(true);

        try {
            const response = await fetchData('CollectionReportAPI', `/${fromDate}/${toDate}/${companyId}/${Istype}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching  Details:', error);
        }
    };


    //handle search
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const wb = XLSX.utils.book_new();

        // Format header caption based on debitororcreditorType
        let headerCaption = "";
        if (Istype === "1") {
            headerCaption = `SalesManWise:  To : ${formatDate(toDate)}`;
        } else if (Istype === "2") {
            headerCaption = `Invoice Type:  To : ${formatDate(toDate)}`;
        } else if (Istype === "3") {
            headerCaption = `BillNo:  To : ${formatDate(toDate)}`;
        }

        const allDataSheet = [];
        allDataSheet.push([headerCaption]);  // Add header caption as the first row

        // Define column headers
        const headerRow = ['Name', 'Date',
            'Bill Details.',
            'Card Amount',
            'cash Amount',
            'UPI Amount'];
        allDataSheet.push(headerRow);  // Add header row

        // Add data rows
        filteredData.forEach((rowData) => {
            const dataRow = [
                rowData.Name,
                formatDate(rowData.BillDate),
                rowData.BillNumberDetails,
                rowData.TotalCardAmount,
                rowData.TotalCashAmount,
                rowData.TotalUPIAmount,

            ];
            allDataSheet.push(dataRow);
        });


        // Calculate total amounts for each type
        const totalCardAmount = filteredData.reduce((sum, rowData) => sum + parseFloat(rowData.TotalCardAmount), 0);
        const totalCashAmount = filteredData.reduce((sum, rowData) => sum + parseFloat(rowData.TotalCashAmount), 0);
        const totalUPIAmount = filteredData.reduce((sum, rowData) => sum + parseFloat(rowData.TotalUPIAmount), 0);

        // Add total row
        allDataSheet.push(['Total', '', '', totalCardAmount.toFixed(2), totalCashAmount.toFixed(2), totalUPIAmount.toFixed(2)]);



        // Convert allDataSheet array to a worksheet
        const allDataWs = XLSX.utils.aoa_to_sheet(allDataSheet);

        // Append the sheet to the workbook
        const sheetName = Istype === "1" ? "SalesManWise" : Istype === "2" ? "InvoiceType" : "BillNo";
        XLSX.utils.book_append_sheet(wb, allDataWs, sheetName);

        // Write the workbook to a file
        XLSX.writeFile(wb, `${sheetName}.xlsx`);
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
    };
    let lastBillDate = null;
    let lastBillNumber = null;


    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedInvoiceType, setSelectedInvoicetype] = useState("");
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);
    const [supplierId, setSupplierId] = useState('0'); // Default to '0'

    const handleInputChange = (newValue) => newValue;

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    // const [columnOrder, setColumnOrder] = useState([
    //     'SL No',
    //     'Name',
    //     'Date',
    //     'Bill Details',
    //     'Card Amount',
    //     'Cash Amount',
    //     'UPI Amount',
    // ]);

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'SL No',
        'Name',
        'Date',
        'Bill Details',
        'Card Amount',
        'Cash Amount',
        'UPI Amount',
    ]);


    // Update columnOrder based on Istype
    useEffect(() => {
        if (Istype === "1") {
            setColumnOrder([
                'SL No',
                'Name', // Include "Name" column for Istype 1
                'Date',
                'Bill Details',
                'Card Amount',
                'Cash Amount',
                'UPI Amount',
            ]);
        } else {
            setColumnOrder([
                'SL No',
                'Date',
                'Bill Details',
                'Card Amount',
                'Cash Amount',
                'UPI Amount',
            ]); // Exclude "Name" column for other Istype values
        }
    }, [Istype]); // Re-run whenever Istype changes




    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };


    const grandTotal = data
        .filter((row) => row) // Ensure `data` is filtered correctly (e.g., remove null or undefined entries)
        .reduce(
            (totals, rowData) => ({
                TotalCardAmount: parseFloat((totals.TotalCardAmount + (parseFloat(rowData.TotalCardAmount) || 0)).toFixed(2)),
                TotalCashAmount: parseFloat((totals.TotalCashAmount + (parseFloat(rowData.TotalCashAmount) || 0)).toFixed(2)),
                TotalUPIAmount: parseFloat((totals.TotalUPIAmount + (parseFloat(rowData.TotalUPIAmount) || 0)).toFixed(2)),
            }),
            {
                TotalCardAmount: 0,
                TotalCashAmount: 0,
                TotalUPIAmount: 0,
            }
        );


    // Process and paginate the data
    const processedData = data.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <div className="w-full mx-auto" style={{ width: '95%', marginTop: '-1%' }}>
              <br />
            <h6
                className="uppercase tracking-wide text-black flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
            >
                Collection Summary
            </h6>
            
            <div className="w-full mb-2 flex" style={{ marginTop: '10px', justifyContent: 'space-between'}}>

                <div className="flex justify-end items-center">
                    <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                        <input
                            type="radio"
                            name="Istype"
                            value="1"
                            checked={Istype === "1"} // This will check the "Creditor" radio button by default
                            onChange={handleIstypechange}
                        />
                        <span style={{ color: 'blue', fontSize: '12px' }}>SalesMan</span>
                    </label>
                    <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                        <input
                            type="radio"
                            name="Istype"
                            value="2"
                            checked={Istype === "2"} // This will check the "Debitor" radio button if it's selected
                            onChange={handleIstypechange}
                        />
                        <span style={{ color: 'brown', fontSize: '12px' }}>InvoiceType</span>
                    </label>
                    <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                        <input
                            type="radio"
                            name="Istype"
                            value="3"
                            checked={Istype === "3"} // This will check the "Debitor" radio button if it's selected
                            onChange={handleIstypechange}
                        />
                        <span style={{ color: 'darkblue', fontSize: '12px' }}>BillNo</span>
                    </label>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginLeft: '30px' }}>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                        <div style={{ maxWidth: '150px', marginRight: '10px', marginTop: '-15px' }}>
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                                htmlFor="fromDate"
                            >
                                From Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={fromDate}
                                onChange={handleFromDateChange}
                            />
                        </div>
                        <div style={{ maxWidth: '150px', marginRight: '10px', marginTop: '-15px' }}>
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                                htmlFor="toDate"
                            >
                                To Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={toDate}
                                onChange={handleToDateChange}
                            />
                        </div>
                        <Button
                            style={{
                                backgroundColor: '#C9E9D2',
                                color: 'black',
                                height: '36px',
                                marginTop: '15px',
                                width: '100px'

                            }}
                            onClick={fetchTableData}
                            className="linkcolor"
                        >
                            <span>Refresh</span>
                        </Button>

                        <Button
                            style={{
                                backgroundColor: '#F6D6D6',
                                color: 'black',
                                height: '36px',
                                marginLeft: '5px',
                                marginTop: '15px'

                            }}
                            onClick={handleExportExcel}
                            className="linkcolor"
                        >
                            <span>Excel</span>
                        </Button>
                    </div>

                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                            <TableRow>
                                {columnOrder.map((col, index) => (
                                    <TableCell
                                        key={index}
                                        style={{
                                            padding: '6px',
                                            cursor: 'move',
                                            color: '#640D5F',
                                            fontWeight: 'bold',
                                            textAlign: ['Card Amount', 'Cash Amount', 'UPI Amount'].includes(col)
                                                ? 'right'
                                                : 'left',
                                        }}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, index)}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {processedData
                                .filter((row) => row)
                                .map((rowData, index) => {
                                    const rowValues = {
                                        'SL No': index + 1,
                                        Name: rowData.Name || '',
                                        Date: rowData.BillDate ? formatDate(rowData.BillDate) : '',
                                        'Bill Details': rowData.BillNumberDetails,
                                        'Card Amount': rowData.TotalCardAmount ? parseFloat(rowData.TotalCardAmount).toFixed(2) : '0.00',
                                        'Cash Amount': rowData.TotalCashAmount ? parseFloat(rowData.TotalCashAmount).toFixed(2) : '0.00',
                                        'UPI Amount': rowData.TotalUPIAmount ? parseFloat(rowData.TotalUPIAmount).toFixed(2) : '0.00',
                                    };

                                    return (
                                        <TableRow
                                            key={rowData.Id || index}
                                            sx={{
                                                backgroundColor:
                                                    rowData.Name === "Master" ? '#D3F1DF' : 'transparent',
                                            }}
                                        >
                                            {columnOrder
                                                .filter((col) => !(col === 'Name' && Istype !== "1"))
                                                .map((col, idx) => (
                                                    <TableCell
                                                        key={idx}
                                                        sx={{
                                                            borderBottom: '1px solid #E4E0E1',
                                                            padding: '5px',
                                                            textAlign: ['Card Amount', 'Cash Amount', 'UPI Amount'].includes(col)
                                                                ? 'right'
                                                                : 'left',
                                                        }}
                                                    >
                                                        {rowValues[col]}
                                                    </TableCell>
                                                ))}
                                        </TableRow>
                                    );

                                })}

                            {/* Grand Total Row */}

                            <TableRow sx={{ backgroundColor: '#F3F3F3', fontWeight: 'bold' }}>
                                {Istype === "1" && (
                                    <>
                                        <TableCell
                                            sx={{ textAlign: 'right', padding: '7px', backgroundColor: '#DFF0D8', fontWeight: 'bold' }}
                                        ></TableCell>
                                    </>
                                )}
                                <TableCell
                                    sx={{ textAlign: 'right', padding: '7px', backgroundColor: '#DFF0D8', fontWeight: 'bold' }}
                                >
                                    Grand Total
                                </TableCell>
                                <TableCell sx={{ textAlign: 'right', padding: '7px', backgroundColor: '#DFF0D8' }}></TableCell>
                                <TableCell sx={{ textAlign: 'right', padding: '7px', backgroundColor: '#DFF0D8' }}></TableCell>
                                <TableCell
                                    sx={{ textAlign: 'right', backgroundColor: '#DFF0D8', padding: '7px', fontWeight: 'bold' }}
                                >
                                    {grandTotal.TotalCardAmount.toFixed(2)}
                                </TableCell>
                                <TableCell
                                    sx={{ textAlign: 'right', backgroundColor: '#DFF0D8', padding: '7px', fontWeight: 'bold' }}
                                >
                                    {grandTotal.TotalCashAmount.toFixed(2)}
                                </TableCell>
                                <TableCell
                                    sx={{ textAlign: 'right', backgroundColor: '#DFF0D8', padding: '7px', fontWeight: 'bold' }}
                                >
                                    {grandTotal.TotalUPIAmount.toFixed(2)}
                                </TableCell>
                            </TableRow>

                        </TableBody>

                        {/* Render Grand Total in Footer */}
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}

                                />
                            </TableRow>


                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );

}
export default CollectionReport;



